import { render, staticRenderFns } from "./relation-select.vue?vue&type=template&id=0e454114&scoped=true&"
import script from "./relation-select.vue?vue&type=script&lang=ts&"
export * from "./relation-select.vue?vue&type=script&lang=ts&"
import style0 from "./relation-select.vue?vue&type=style&index=0&id=0e454114&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e454114",
  null
  
)

export default component.exports